import {
  ModalForm,
  ProFormDateTimePicker,
  ProFormSelect,
  ProFormText,
} from '@ant-design/pro-components';
import PropTypes from 'prop-types';
import { createCollection, updateCollection } from '../services/collect';
import {
  getCollectionStartTimeInitialValue,
  serializeCollectionStartTime,
} from '../utils/collection-time';

const AgentHoseCollectionForm = ({
  collectionType,
  connections,
  onSaved,
  organizationId,
  record,
  trigger,
}) => {
  const editing = Boolean(record);
  return (
    <ModalForm
      title={editing ? '修改采集配置' : '创建采集配置'}
      trigger={trigger}
      width={520}
      initialValues={
        record
          ? {
              ...record,
              sourceConfig: {
                ...record.sourceConfig,
                startTime: getCollectionStartTimeInitialValue(record.sourceConfig.startTime),
              },
            }
          : undefined
      }
      modalProps={{ destroyOnHidden: true }}
      onFinish={async (values) => {
        await (editing ? updateCollection : createCollection)({
          data: {
            ...values,
            collectionType,
            id: record?.id,
            organizationId,
            sourceConfig: {
              startTime: serializeCollectionStartTime(values.sourceConfig.startTime),
            },
          },
        });
        onSaved();
        return true;
      }}
    >
      <ProFormText name="name" label="采集配置名称" rules={[{ required: true }]} />
      <ProFormSelect
        name="connectionId"
        label="合思连接"
        options={connections.map(({ id, name }) => ({ label: name, value: id }))}
        rules={[{ required: true }]}
      />
      <ProFormDateTimePicker
        name={['sourceConfig', 'startTime']}
        label="采集起始时间"
        rules={[{ required: true }]}
      />
    </ModalForm>
  );
};

AgentHoseCollectionForm.propTypes = {
  collectionType: PropTypes.string.isRequired,
  connections: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string.isRequired }),
  ).isRequired,
  onSaved: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
  record: PropTypes.shape({
    connectionId: PropTypes.string.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    sourceConfig: PropTypes.shape({ startTime: PropTypes.number.isRequired }).isRequired,
  }),
  trigger: PropTypes.node.isRequired,
};

export default AgentHoseCollectionForm;
